(function () {
    const cancelIdleCallbackShim = function (id) {
        clearTimeout(id);
    };
    return (window.cancelIdleCallback = window.cancelIdleCallback || cancelIdleCallbackShim);
})();
